import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import PendingAuthService from "../../../services/approvals.service";
import Remarks from "./remarks";
import CommonOtp from "../../../components/otp";
import { Breadcrumb, Button, Card, Checkbox, Empty, Modal, Select } from "antd";
import download from "../../../assests/icons/download_icon.png";
import SelectAllCard from "../../../components/pending-approvals/selectAll";
import { AiOutlineLeft } from "react-icons/ai";
import BillerCard from "../../../components/pending-approvals/biller";
import { CONFIG } from "../../../environment";
import { ReactComponent as TitleIcon } from "../../../assests/images/transfer.svg";
import { useTranslation } from "react-i18next";
import BillerBeneGrid from "../../../components/pending-approvals/approval-grids/biller-bene-grid";
import BillerBeneList from "../../../components/pending-approvals/approval-lists/biller-bene-list";
import { ReactComponent as HomeIcon } from "../../../assests/images/home-line.svg";

export default function PendingBillerBeneficiary() {
  const navigate = useNavigate();
  const [stage, setStage] = useState(1);
  const [dataSource, setDataSource] = useState([]);
  const [noRecords, setNoRecords] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState({});
  const [formValues, setFormValues] = useState({});
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [responseList, setResponseList] = useState([]);
  const [reqValues, setReqValues] = useState({});
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [messageList, setMessageList] = useState([]);
  const [showMoreRecordModal, setShowMoreRecordModal] = useState(false);
  const [otp, setOtp] = useState("");
  const { t } = useTranslation();
  const [showGridAccount, setShowGridAccount] = useState("GRID");

  useEffect(() => {
    if (window.innerWidth < 900) {
      setShowGridAccount("LIST");
    }
  }, [window.innerWidth]);

  useEffect(() => {
    getPendingRecords();
  }, []);

  const getPendingRecords = useCallback(async () => {
    try {
      const response = await PendingAuthService.billerBeneGetRecords({
        listType: "P",
      });
      if (response.status === 200) {
        setDataSource(response.data);
      }
    } catch (error) {}
  }, []);

  const handleSelectAll = useCallback(
    (checked) => {
      try {
        const dataSourceCopy = [...dataSource];
        dataSourceCopy.forEach((ele) => {
          ele.isChecked = checked;
        });
        setDataSource(dataSourceCopy);
        setSelectAllChecked(checked);
      } catch (err) {}
    },
    [dataSource]
  );

  const handleCheckBoxChange = useCallback(
    (value, selected) => {
      try {
        const dataSourceCopy = [...dataSource];
        dataSourceCopy.forEach((ele) => {
          if (ele.id === selected.id) {
            ele.isChecked = value;
          }
        });
        setDataSource(dataSourceCopy);
        setSelectAllChecked(dataSourceCopy.every((ele) => ele.isChecked));
      } catch (err) {}
    },
    [dataSource]
  );

  const handleMultiApproveOrReject = useCallback(
    (type) => {
      try {
        const selectedReqs = dataSource
          .filter((ele) => ele.isChecked === true)
          .map((record) => {
            return record.id;
          });
        setReqValues({
          reqIds: [...selectedReqs],
          authType: type,
        });
        setStage(2);
      } catch (err) {}
    },
    [dataSource]
  );

  const handleApproveOrReject = useCallback(async (selected, type) => {
    try {
      setSelectedDetails(selected);
      setReqValues({
        reqIds: [selected.id],
        authType: type,
      });
      setStage(2);
    } catch (err) {}
  }, []);

  const handleDelete = useCallback(async (selected) => {
    try {
      const reqParams = {
        reqIds: [selected.id],
      };
      const response = await PendingAuthService.billerBeneDelete(reqParams);
      if (response.status === 200) {
        setShowModal(true);
        setMessage(response.data["data"][0]["message"]);
      }
    } catch (err) {}
  }, []);

  const handleMultiDelete = useCallback(async () => {
    try {
      const selectedReqs = dataSource
        .filter((ele) => ele.isChecked === true)
        .map((record) => {
          return record.id;
        });
      const reqParams = {
        reqIds: [...selectedReqs],
      };
      const response = await PendingAuthService.billerBeneDelete(reqParams);
      if (response.status === 200) {
        setShowMoreRecordModal(true);
        setMessageList(response.data["data"]);
      }
    } catch (err) {}
  }, [dataSource]);

  const handleDownload = useCallback(async () => {
    try {
      const reqParams = {
        listType: "P",
      };
      await PendingAuthService.billerDownload(reqParams);
    } catch (err) {}
  }, []);

  const onVerify = useCallback(
    async (values) => {
      try {
        setFormValues(values);
        const reqParams = {
          ...reqValues,
        };
        const response = await PendingAuthService.billerBeneAuthVerify(
          reqParams
        );
        if (response.status === 200) {
          if (response.data["otpEnabled"]) {
            setStage(3);
            return;
          }
          await onConfirm({
            ...values,
            ...reqValues,
            otp: CONFIG.DEFAULT_OTP,
          });
        }
      } catch (err) {}
    },
    [reqValues]
  );

  const onConfirm = useCallback(async (values) => {
    try {
      const authReqList = [];
      values?.reqIds?.forEach((element) => {
        authReqList.push({
          authorizerComments: values.authorizerComments,
          reqId: element,
        });
      });

      const reqParams = {
        authReqList: [...authReqList],
        otp: values.otp,
        authType: values.authType,
        enabledTOTP: values.enabledTOTP,
      };

      const response = await PendingAuthService.billerBeneAuthConfirm(
        reqParams
      );
      if (response.status === 200) {
        setResponseList(response.data);
        //await getPendingRecords()
        setStage(4);
      }
    } catch (err) {
      setOtp("");
    }
  }, []);

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return (
          <Card className="col-12 application-card">
            <Remarks onVerify={onVerify} goBack={() => setStage(1)} />
          </Card>
        );

      case 3:
        return (
          <Card className="col-12 application-card">
            <CommonOtp
              otp={otp}
              setOtp={setOtp}
              onConfirm={(values) =>
                onConfirm({
                  ...formValues,
                  ...values,
                  ...reqValues,
                })
              }
              handleResendOtp={() => onVerify()}
              cancelTransaction={() => {
                setStage(1);
              }}
            />
          </Card>
        );

      case 4:
        return renderSuccess();
      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <Card className="application-card">
        {showGridAccount === "GRID" && (
          <BillerBeneGrid
            dataSource={dataSource}
            handleSelectAll={handleSelectAll}
            handleMultiApproveOrReject={handleMultiApproveOrReject}
            selectAllChecked={selectAllChecked}
            handleMultiDelete={handleMultiDelete}
            handleCheckBoxChange={handleCheckBoxChange}
            handleApproveOrReject={handleApproveOrReject}
            handleDelete={handleDelete}
          />
        )}
        {showGridAccount === "LIST" && (
          <BillerBeneList
            dataSource={dataSource}
            handleSelectAll={handleSelectAll}
            handleMultiApproveOrReject={handleMultiApproveOrReject}
            selectAllChecked={selectAllChecked}
            handleMultiDelete={handleMultiDelete}
            handleCheckBoxChange={handleCheckBoxChange}
            handleApproveOrReject={handleApproveOrReject}
            handleDelete={handleDelete}
          />
        )}
      </Card>
    );
  }

  function renderSuccess() {
    return (
      <Card className="application-card">
        <div className="dashboard-accounts-wrapper">
          {showGridAccount === "GRID" && (
            <div className="send-money-container table-body card-padding">
              {responseList.length > 0 && (
                <table className="table">
                  <thead style={{ backgroundColor: "#F1F1F1" }}>
                    <tr>
                      <th>
                        {" "}
                        {t("pages.pending_approval.consumer_number", {
                          defaultValue: "Consumer Number",
                        })}
                      </th>
                      <th>
                        {" "}
                        {t("pages.my_accounts.casa.nickname", {
                          defaultValue: "Nick Name",
                        })}
                      </th>
                      <th>
                        {t("common.message", {
                          defaultValue: "Message",
                        })}
                      </th>
                      <th>{t("common.status", { defaultValue: "Status" })}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {responseList.map((option, index) => (
                      <tr key={index}>
                        <td>{option?.consumerNo}</td>
                        <td>{option?.nickName}</td>
                        <td
                          style={{
                            whiteSpace: "break-spaces",
                            wordBreak: "break-all",
                          }}
                        >
                          {option?.message}
                        </td>
                        <td>{option?.status || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          )}
          {showGridAccount === "LIST" &&
            responseList.map((option, idx) => (
              <div key={idx}>
                <div className="account-row-data list-row mb-2">
                  <div>
                    <div>{option?.consumerNo}</div>

                    <div
                      style={{
                        whiteSpace: "break-spaces",
                        wordBreak: "break-all",
                      }}
                    >
                      {option?.message}
                    </div>
                  </div>
                  <div align="right">
                    <div>{option?.nickName}</div>
                    <div>{option?.status || "-"}</div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </Card>
    );
  }

  function renderDeleteSuccess() {
    return (
      <>
        {showGridAccount === "GRID" && (
          <Card className="application-card">
            {messageList.length > 0 && (
              <div className="ft-table">
                {" "}
                <table className="table">
                  <thead style={{ backgroundColor: "#F1F1F1" }}>
                    <tr>
                      <th>
                        {" "}
                        {t("pages.pending_approval.consumer_number", {
                          defaultValue: "Consumer Number",
                        })}
                      </th>
                      <th>
                        {t("pages.pay_bills.biller_name", {
                          defaultValue: "Biller Name",
                        })}
                      </th>
                      <th>
                        {t("common.message", {
                          defaultValue: "Message",
                        })}
                      </th>
                      <th>{t("common.status", { defaultValue: "Status" })}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {messageList.map((option, index) => (
                      <tr key={index}>
                        <td>{option?.consumerId}</td>
                        <td>{option?.billerName}</td>
                        <td
                          title={option?.message}
                          style={{
                            whiteSpace: "break-spaces",
                            wordBreak: "break-all",
                          }}
                        >
                          {option?.message}
                        </td>
                        <td>{option?.status || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </Card>
        )}
        {showGridAccount === "LIST" &&
          messageList.map((option, idx) => (
            <div key={idx}>
              <div className="account-row-data list-row mb-2">
                <div>
                  <div>{option?.billerName || "-"}</div>
                  <div
                    style={{
                      whiteSpace: "break-spaces",
                      wordBreak: "break-all",
                    }}
                  >
                    {option?.message}
                  </div>
                </div>
                <div align="right">
                  <div>{option?.consumerId || "-"}</div>
                  <div>{option?.status || "-"}</div>
                </div>
              </div>
            </div>
          ))}
      </>
    );
  }

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/pending-authorization")}>
              {t("navigation.approval", {
                defaultValue: "Approval",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("navigation.biller_bene", {
                defaultValue: "Biller Beneficiary",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("navigation.biller_bene", {
                defaultValue: "Biller Beneficiary",
              })}
            </h3>
          </div>
          {stage === 1 && (
            <div className=" col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-end">
              {dataSource.length === 0 ? null : (
                <Button
                  type="default"
                  className="btn-primary"
                  onClick={handleDownload}
                >
                  <img
                    alt="download"
                    src={download}
                    height={20}
                    style={{ paddingRight: "15px" }}
                  />
                  {t("buttons.download_btn", { defaultValue: "Download" })}
                </Button>
              )}
            </div>
          )}
        </div>
      </Card>

      {renderSwitch()}

      <Modal
        open={showModal}
        footer={null}
        width={450}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <div
          style={{ width: 320, margin: "0 auto" }}
          align="center"
          className="mt-2"
        >
          <h6
            className="auth-header-label"
            style={{ textTransform: "initial" }}
          >
            {message}
          </h6>
          <div className="mt-4 mb-3" align="center">
            <Button
              type="default"
              className="secondary-btn"
              style={{ width: 120 }}
              size="large"
              onClick={() => {
                setShowModal(false);
                navigate("/pending-authorization");
              }}
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        open={showMoreRecordModal}
        footer={null}
        width={700}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <div
          style={{ width: 650, margin: "0 auto" }}
          align="center"
          className="mt-2"
        >
          <h6
            className="auth-header-label"
            style={{ textTransform: "initial" }}
          >
            {renderDeleteSuccess()}
          </h6>
          <div className="mt-4 mb-3" align="center">
            <Button
              type="default"
              className="secondary-btn"
              style={{ width: 120 }}
              size="large"
              onClick={() => {
                setShowModal(false);
                navigate("/pending-authorization");
              }}
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
